import { Breadcrumbs } from "@/components/ui/breadcrumbs";
import { H2 } from "@/components/ui/typography";
import { APDUpload } from "@/features/apd/APDUpload";

export function APDCreate() {
  return (
    <>
      <Breadcrumbs
        list={[
          {
            label: "Master Data",
          },
          {
            href: "/master-data/apd",
            label: "APD",
          },
          {
            label: "Add",
          },
        ]}
      />
      <H2>Add APD</H2>
      <APDUpload />
    </>
  );
}
